import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminDashboard() {
    const [stats, setStats] = useState({ leads: 0, posts: 0, newLeads: 0, agents: 0, newAgents: 0 });

    useEffect(() => {
        Promise.all([
            api.get("/leads"),
            api.get("/admin/blog/posts"),
            api.get("/agents"),
        ]).then(([l, p, a]) => {
            const leads = l.data || [];
            const agents = a.data || [];
            setStats({
                leads: leads.length,
                posts: (p.data || []).length,
                newLeads: leads.filter((x) => x.status === "new").length,
                agents: agents.length,
                newAgents: agents.filter((x) => x.status === "new").length,
            });
        }).catch(() => {});
    }, []);

    return (
        <div className="p-10" data-testid="admin-dashboard">
            <h1 className="font-serif text-3xl text-brand-ink mb-2">Dashboard</h1>
            <p className="text-sm text-brand-muted mb-10">Overview of activity on RealtorReferral.ca</p>

            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-brand-line border border-brand-line">
                <StatCard label="Total leads" value={stats.leads} testId="stat-leads" />
                <StatCard label="New leads" value={stats.newLeads} testId="stat-new-leads" />
                <StatCard label="Agent applications" value={stats.agents} testId="stat-agents" />
                <StatCard label="New applications" value={stats.newAgents} testId="stat-new-agents" />
                <StatCard label="Journal posts" value={stats.posts} testId="stat-posts" />
            </div>
        </div>
    );
}

function StatCard({ label, value, testId }) {
    return (
        <div className="bg-brand-paper p-8" data-testid={testId}>
            <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold mb-3">
                {label}
            </div>
            <div className="font-serif text-5xl text-brand-ink">{value}</div>
        </div>
    );
}
